import { mapState, mapGetters, mapMutations } from "vuex";
import { mainFunctions } from "../mixins/mainFunctions";

export const modalPrice = {
  mixins: [mainFunctions],
  computed: {
    ...mapState(["resumeData", "localDate"]),
    ...mapGetters({
      getCurrEngine: "enginesData/getFullEngineByID",
      getCurrVersion: "versionsData/getVersionById",
      modelPrice: "resumeData/getFullPrice",
      getEngine: "enginesData/getEngineById",
    }),
    handleModalFinTitle() {
      const financesData = this.resumeData.hasFinances;
      let param = this.modalParam; // carCard | ConfigCard | else here
      let obj = {};

      if (param == 0) obj = this.modelObj;

      if (param == 1 || param == 2) {
        obj.model = this.resumeData?.model;
      }

      if (param == 1) {
        let item = this.itemObj;
        obj.version = item.designation;
        obj.price = item.price;
      }

      if (param == 2) {
        let item = this.__setCurrObj;
        obj.version = item.designation;
        obj.price = this.modelPrice;
      }

      // ignore data from API and use data from sifa
      if (financesData) {
        obj.price = financesData.pvp;
        obj.rent = financesData.fee;
      }

      let res = {
        modelName: obj?.model,
        versionName: obj?.version,
        totalPriceFormated: parseFloat(obj?.price).toFixed(0),
        rentFormated: parseFloat(obj?.rent).toFixed(2),
      };

      return res;
    },

    handleModalFinData() {
      const financesData = this.resumeData.hasFinances;
      let param = this.modalParam; // carCard | ConfigCard | else here
      let resumeObj = this.resumeData;
      let obj = {};
      let colorPrice = 0;

      if (param == 0) {
        Object.assign(obj, this.modelObj);
        colorPrice = obj.metalicColorPrice;
      }

      if (param == 1) {
        Object.assign(obj, this.itemObj);
        obj.version = obj.designation;
      }

      if (param == 2) {
        Object.assign(obj, this.__setCurrObj);
        let item = this.__setCurrObj;
        obj.version = item.designation;
      }

      if (param == 1 || param == 2) {
        let engineData = this.getEngine(resumeObj.selectedEngine);
        let colorPricesArr = this.__hasColors();

        obj.model = resumeObj.model;
        obj.id = resumeObj.modelid;

        obj.co2 = engineData.co2;
        obj.fuelCC = engineData.fuelCC;
        colorPrice = colorPricesArr.colExt + colorPricesArr.colInt;
      }

      let capitalToFinance = obj.price - obj.maxEntrance;
      let costs = obj.legalizationGain + obj.transportGain + obj.ecoValue; //legalização e transporte e ecovalor

      if (financesData) {
        obj.nrPayments = financesData.nrPayments;
        obj.price = financesData.pvp;
        obj.maxEntrance = financesData.initialValue;
        obj.initialExpenses = financesData.initialExpenses;
        obj.rate = financesData.rate;
        obj.taeg = financesData.taeg;
        obj.mtic = financesData.mtic;
        obj.rent = financesData.fee;
        obj.postExpenses = financesData.postExpenses;
        obj.date = this.buildDateString(financesData.dtEndOfCampaign);

        capitalToFinance = financesData.capitalToFinance;
      } else {
        obj.date = this.buildDateString(obj.dtEndOfCampaign);
      }

      let res = {
        modelName: obj.model,
        modelid: obj.id,
        versionName: obj.version,
        co2: obj.co2,
        fuelConsumptionCombined: obj.fuelCC,
        nrPayments: obj.nrPayments,
        totalPriceFormated: parseFloat(obj.price).toFixed(0),
        initialValueFormated: parseFloat(obj.maxEntrance).toFixed(2),
        capitalToFinanceFormated: parseFloat(capitalToFinance).toFixed(0),
        initialExpensesFormated: parseFloat(obj.initialExpenses).toFixed(2),
        rate: parseFloat(obj.rate).toFixed(2),
        taeg: parseFloat(obj.taeg).toFixed(1),
        mticFormated: obj.mtic,
        rentFormated: parseFloat(obj.rent).toFixed(2),
        pvpWithoutFinanceFormated: parseFloat(obj.pvpWithoutFinance).toFixed(0),
        paiting: parseFloat(colorPrice).toFixed(0),
        costs: parseFloat(costs).toFixed(2),
        date: obj.date,
        postExpenses: parseFloat(obj.postExpenses).toFixed(2),
      };

      if (this.resumeData.creditType == "HOD" && financesData.residualValue)
        res.resiudalValue = financesData.residualValue.toFixed(2);

      return res;
    },

    __setCurrObj() {
      let resume = this.resumeData;
      let currPathName = this.$route.name;
      let obj = null;

      if (currPathName == "Motors")
        obj = this.getCurrEngine(resume.selectedEngine);
      else obj = this.getCurrVersion(resume.versionID);

      return obj;
    },
  },
  methods: {
    ...mapMutations({
      updateModal: "modalData/UPDATE_MODALSTATE",
    }),
    __hasColors() {
      let resume = this.resumeData;
      let colExt = 0;
      let colInt = 0;
      if (resume.configSelected.dsgExt)
        colExt = resume.configSelected.dsgExt.price;
      if (resume.configSelected.dsgInt)
        colInt = resume.configSelected.dsgInt.price;
      return { colExt: colExt, colInt: colInt };
    },
    showModalPrice(title, data) {
      this.updateModal({
        openModal: true,
        component: "DefaultModalContent",
        title: title,
        content: data,
      });
    },
    setModalTitle(arr, isRent = false) {
      if (isRent)
        return `Preço com Campanha de Financiamento desde ${this.formatThousands(
          arr.rentFormated,
          true,
          2
        )}  €/mês - ${arr.modelName} ${arr.versionName}`;
      return `Preço com Campanha de Financiamento desde ${this.formatThousands(
        arr.totalPriceFormated
      )}  € - ${arr.modelName} ${arr.versionName}`;
    },
    setFinanceContent(isCRED = false, arr) {
      if (isCRED) {
        let colorsMsg =
          arr.paiting > 0
            ? ` nem custos adicionais de opção de pintura (desde ${arr.paiting} € )`
            : "";

        return (
          `
          * Exemplo para Crédito Automóvel com reserva de propriedade. PVP: ${this.formatThousands(
            arr.totalPriceFormated
          )} € (acresce IUC), entrada: ${this.formatThousands(
            arr.initialValueFormated
          )} € , ${arr.nrPayments} mensalidades: ${this.formatThousands(
            arr.rentFormated,
            true
          // )} € incluindo ${this.formatThousands(
          //   arr.postExpenses,
          //   true
          )} €. Montante Financiado: ${this.formatThousands(
            arr.capitalToFinanceFormated
          )} €. Comissão de Abertura de Contrato: ${this.formatThousands(
            arr.initialExpensesFormated
          )} € e ISUC à taxa legal em vigor. Extinção de reserva 32,50€. TAN ${this.formatThousands (
            arr.rate,
            true,
            1
          )}%,TAEG ${this.formatThousands(
            arr.taeg,
            true,
            1
          )}%, MTIC: ${this.formatThousands(
            arr.mticFormated,
            true
          )} €. <b>Campanha válida até ${
            arr.date
          }</b>, para o ${arr.modelName} ${
            arr.versionName
          }, limitada ao stock existente e disponível nos concessionários aderentes. Crédito sujeito a aprovação pelo Cetelem, marca BNPP PF, Sucursal em Portugal (Registo BdP 848), junto do qual se deverá informar. A Hyundai Portugal, S.A. é intermediário de crédito a título acessório, sem exclusividade (Registo BdP 6278). <b>Valor de PVP sem financiamento no montante de ${this.formatThousands(
            arr.pvpWithoutFinanceFormated
          )} €.</b> Valor não inclui despesas de legalização e transporte (${
            arr.costs
          } € + IVA em Portugal Continental)` +
          colorsMsg +
          `. A imagem pode não corresponder ao modelo em campanha. Consumo combinado (l/100km): ${arr.fuelConsumptionCombined}. Emissões de CO2 em ciclo combinado (g/km):${arr.co2}. A garantia de 7 anos sem limite de quilómetros da Hyundai é apenas aplicável aos veículos ligeiros de passageiros matriculados a partir de 1 de setembro de 2019, vendidos por um concessionário autorizado da rede Oficial Hyundai Portugal a um consumidor final, de acordo com os Termos e Condições constantes no Passaporte de Serviço. Campanha válida para clientes registados no myHYUNDAI.
                `
        );
      }

      return `
      * Exemplo para Crédito Automóvel com reserva de propriedade. PVP: ${this.formatThousands(
        arr.totalPriceFormated
      )} €, entrada inicial obrigatória: ${this.formatThousands(
        arr.initialValueFormated
      )} € + ${arr.nrPayments - 1} mensalidades: ${this.formatThousands(
        arr.rentFormated
      )} € incluindo ${this.formatThousands(
        arr.postExpenses,
        true
      )} € de comissão de gestão de contrato, última mensalidade: ${
        arr.resiudalValue
      } €. Comissão de Abertura de Contrato: ${this.formatThousands(
        arr.initialExpensesFormated
      )} €, TAN ${arr.rate}%, TAEG ${this.formatThousands(
        arr.taeg
      )}%, MTIC: ${this.formatThousands(
        arr.mticFormated
      )} €. Imposto de Selo à taxa legal em vigor. Ao PVP acresce o IUC. Campanha válida até ${
        arr.date
      }, para o Hyundai  ${arr.modelName} ${
        arr.versionName
      }, limitada ao stock existente e disponível nos concessionários aderentes. Crédito sujeito a aprovação pelo Cetelem, marca BNP Paribas Personal Finance, S.A., Sucursal em Portugal, registada no Banco de Portugal sob o n.º 848. Informe-se no 21 721 90 00 (dias úteis, 9-20h), custo chamada conforme tarifa contratada para rede fixa nacional. A Hyundai Portugal, S.A., registada no Banco de Portugal sob o n.º 6278, e todos os concessionários são intermediários de Crédito a título acessório e atuam sem carácter de exclusividade. Valor não inclui custos adicionais de opção de pintura (desde ${
        arr.costs
      } € com IVA incluído). A imagem pode não corresponder ao modelo em campanha. Consumo combinado (l/100km): ${
        arr.fuelConsumptionCombined
      }. Emissões de CO2 em ciclo combinado (g/km):  ${
        arr.co2
      }. A garantia de 7 anos sem limite de quilómetros da Hyundai é apenas aplicável aos veículos ligeiros de passageiros matriculados a partir de 1 de setembro de 2019, vendidos por um concessionário autorizado da rede Oficial Hyundai Portugal a um consumidor final, de acordo com os Termos e Condições constantes no Passaporte de Serviço.
            `;
    },
  },
};
